export const updateAlienPosition = 'update-alien-position'
export const setLevel = 'set-level'
export const nextLevel = 'next-level'
export const levelCompleted = 'level-completed'
export const selectAlien = 'select-alien'
export const killAlien = 'kill-alien'
export const screenOrientationChanged = 'screen-orientation-changed'
export const screenSizeChanged = 'screen-size-changed'
export const undo = 'undo'
export const move = 'move'
export const glowAlien = 'glow-alien'